import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  gettingAddOnOrderListByIdsApi,
  gettingJobListByIdsApi,
  gettingMyOrdersDetailsApi,
  gettingMyOrdersListApi,
  gettingPendingOrdersListApi,
  rescheduledJobsApi,
} from "../../services/api/ordersApis";
import { loadingContentForStaffAvailability } from "../../utils/constants";
import { setLoadingContent } from "./loadingSlice";
import { toast } from "react-toastify";
import { setClearOrder } from "./createOrderSlice";
import http from "../../services/api/http";


const initialState = {
  myOrdersList: [],
  isFetching: false,
  error: null,
  isError: false,
  myOrdersDetails: null,
  dataCount: 0,
  dataPerPage: 10,
  currentpage: 1,
  dataRange: null,
  jobOrdersListsById: [],
  addOnOrderListToShowById: [],
  companyBlockDates: []
};

export const getMyOrdersListings = createAsyncThunk(
  "get/my-orders/lists",
  async (values, { rejectWithValue }) => {
    try {
      const data = await gettingMyOrdersListApi(values);

      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const orderDetailsById = createAsyncThunk(
  "details/byId",
  async (values, { rejectWithValue }) => {
    try {
      const data = await gettingMyOrdersDetailsApi(values);
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const orderJobListById = createAsyncThunk(
  "jobList/byId",
  async (values, { rejectWithValue }) => {
    try {
      const data = await gettingJobListByIdsApi(values);
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const addOnOrderListById = createAsyncThunk(
  "jobList/add-on-order/byId",
  async (values, { rejectWithValue }) => {
    try {
      const data = await gettingAddOnOrderListByIdsApi(values);
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const rescheduleJob = createAsyncThunk(
  "reschedule/job",
  async (values, { rejectWithValue }) => {
    try {
      values.dispatch(setLoadingContent(loadingContentForStaffAvailability));
      const data = await rescheduledJobsApi(values?.data);
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      if (data?.serverResponse?.code === 200) {
        toast.success('Re-scheduling is successful')
        values.navigate("/booking");
        values.dispatch(setLoadingContent([]));
        values.dispatch(setClearOrder())
        return data;
      }
    } catch (error) {
      values.dispatch(setLoadingContent([]));
      return rejectWithValue(error.response.data);
    }
  }
);

export const getPendingOrdersListings = createAsyncThunk(
  "get/pendingOrders/lists",
  async (values, { rejectWithValue }) => {
    try {
      const data = await gettingPendingOrdersListApi(values);

      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Block Dates for calender

export const getMonthlyBlockDates = createAsyncThunk(
  "/block-date-list",
  async (values, { rejectWithValue }) => {
    let url;
    url = `/order/block-date-list?currentPage=${values?.currentPage}&limit=${values?.limit}`;
    try {
      const response = await http.post(url, values);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    clearOrders: (state) => {
      state.dataRange = null;
    },
    clearOrdersList: (state) => {
      state.myOrdersList = [];
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      state.dataCount = 0;
      state.dataPerPage = 10;
      state.currentpage = 1;
      state.dataRange = null;
    },
  },
  extraReducers: {
    [getMyOrdersListings.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [getMyOrdersListings.fulfilled]: (state, { payload }) => {
      state.myOrdersList = [
        ...state.myOrdersList,
        ...payload.result?.data?.data,
      ];
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      state.dataCount = payload.result?.data?.pagination?.totalResults;
      state.dataPerPage = payload.result?.data?.pagination?.limit;
      state.currentpage = payload.result?.data?.pagination?.page;
      state.dataRange = payload.result?.data?.pagination?.dataRange;
      return state;
    },
    [getMyOrdersListings.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [orderDetailsById.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [orderDetailsById.fulfilled]: (state, { payload }) => {
      state.myOrdersDetails = payload?.result?.data;
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [orderDetailsById.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [orderJobListById.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [orderJobListById.fulfilled]: (state, { payload }) => {
      state.jobOrdersListsById = payload?.result;
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [orderJobListById.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [addOnOrderListById.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [addOnOrderListById.fulfilled]: (state, { payload }) => {
      state.addOnOrderListToShowById = payload?.result;
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [addOnOrderListById.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [rescheduleJob.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [rescheduleJob.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [rescheduleJob.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [getPendingOrdersListings.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [getPendingOrdersListings.fulfilled]: (state, { payload }) => {
      state.myOrdersList = [
        ...state.myOrdersList,
        ...payload.result?.data?.data,
      ];
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      state.dataCount = payload.result?.data?.pagination?.totalResults;
      state.dataPerPage = payload.result?.data?.pagination?.limit;
      state.currentpage = payload.result?.data?.pagination?.page;
      state.dataRange = payload.result?.data?.pagination?.dataRange;
      return state;
    },
    [getPendingOrdersListings.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [getMonthlyBlockDates.fulfilled]: (state, { payload }) => {
      state.companyBlockDates = payload?.result?.list;
      return state;
    },
  },
});

// this is for dispatch
export const { clearOrders, clearOrdersList } = ordersSlice.actions;

// this is for configureStore
export default ordersSlice.reducer;
